export const ERROR_MESSAGES: Record<string, string> = {
  // HTTP status codes
  400: 'リクエストの内容に問題があります',
  401: '認証の有効期限が切れました。再度ログインしてください',
  403: '権限がありません',
  404: 'リソースが見つかりません',
  409: 'データが競合しています。ページを再読み込みしてください',
  422: '入力内容に問題があります',
  429: 'リクエスト制限に達しました。しばらくお待ちください',
  500: '少し時間をおいてから、もう一度お試しください',
  502: '少し時間をおいてから、もう一度お試しください',
  503: 'ただいま混み合っています。少し時間をおいてから再度お試しください',

  // BE error codes
  QUOTA_EXCEEDED: 'プランの上限に達しました',
  FILE_TOO_LARGE: 'ファイルサイズが上限を超えています',
  DOMAIN_LIMIT_REACHED: 'チャットBOTの作成上限に達しました',
  INVALID_FILE_TYPE: '対応していないファイル形式です',
  SUBSCRIPTION_REQUIRED: '有料プランへの加入が必要です',
  DUPLICATE_ENTRY: '同じデータが既に登録されています',
  RATE_LIMIT_EXCEEDED: '操作回数の上限に達しました',
  TIMEOUT: '少し時間をおいてから、もう一度お試しください',
  NETWORK_ERROR: 'ネットワーク接続をご確認いただき、もう一度お試しください',
  UNKNOWN: '少し時間をおいてから、もう一度お試しください',
};

const OPERATION_ERROR_MESSAGES: Record<string, string> = {
  create: '作成に失敗しました',
  update: '更新に失敗しました',
  delete: '削除に失敗しました',
  upload: 'アップロードに失敗しました',
  fetch: '取得に失敗しました',
  submit: '送信に失敗しました',
  auth: '認証に失敗しました',
};

export const getErrorMessageByCode = (code: string): string => {
  return ERROR_MESSAGES[code] ?? ERROR_MESSAGES['UNKNOWN'];
};

export const getOperationErrorMessage = (operation: string): string => {
  return OPERATION_ERROR_MESSAGES[operation] ?? '操作に失敗しました';
};
